import React from 'react';
import { Typography } from '@material-ui/core';

type Props = {
  isInitialEvaluation?: boolean;
};

const PsychiatryVisitType: React.FC<Props> = ({ isInitialEvaluation }) => {
  return <Typography>{isInitialEvaluation ? 'Initial Evaluation' : 'Follow-Up'}</Typography>;
};

export default PsychiatryVisitType;
